import * as qs from 'qs';
import {API} from './API';

export class RunningCostService {
  async getTableCosts(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getCosts(query, page, length);
  }

  async getCosts(query, page, length) {
    return (await API.getConnection())
      .get('running-costs', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async getCost(id, archive = false) {
    return (await API.getConnection())
      .get(`running-costs/${id}`, {
        params: archive ? {filter: {archive: 'only'}} : {},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async saveCost(data) {
    let method = 'post';
    let url = 'running-costs';
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
